<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE FAR REACHES</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<h2 class="h2"><a id="page_1"></a><a id="part1"></a>PART I</h2>
<p class="part">Tarawa</p>
<p class="centerc"><em>Watchman, tell us of the night,<br/>What its signs of promise are.<br/>Traveler, over yon mountain’s height,<br/>See that glory-beaming star!</em></p>
<p class="centerc"><em>Watchman, does its beauteous ray<br/>Aught of joy or hope foretell?<br/>Traveler, yes; it brings the day,<br/>Promised day of Israel.</em></p>
<p class="centerc">—J<span class="smallcaps">OHN</span> B<span class="smallcaps">OWRING, A HYMN</span><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?014e4041